import { useMemo } from 'react';
import { useTrainingTeamMembers } from '../../../../lib/api/swrApi';
import { teamMemberAdapter } from './CourseTeams.utils';
import { adaptArrayToTableObject } from '../TableManager/TableManager.utils';
import { TRAINING_TEAM_MEMBERS_SUMMARY } from '../../../../lib/constants/courses';
import BaseReportDialog, { BaseReportDialogProps } from '../BaseReportDialog/BaseReportDialog';
import { Api } from '../../../../lib/types/apiSpec';

type TrainingTeamMemberDialogProps = { id: string; type: Api.TrainingType; teamid: string } & Omit<
  BaseReportDialogProps,
  'data'
>;

const TrainingTeamMemberDialog = ({ id, type, teamid, ...rest }: TrainingTeamMemberDialogProps) => {
  const { data, isLoading } = useTrainingTeamMembers({ id, type, teamid });

  const tableData = useMemo(
    () => data?.map(teamMemberAdapter).reduce(adaptArrayToTableObject(TRAINING_TEAM_MEMBERS_SUMMARY), {}),
    [type, data],
  );

  return (
    <BaseReportDialog
      {...rest}
      data={tableData ?? {}}
      isInitialLoad={isLoading}
      headings={TRAINING_TEAM_MEMBERS_SUMMARY}
    />
  );
};

export default TrainingTeamMemberDialog;
